module.exports = __webpack_public_path__ + "img/product1.84cb9d89.png";